import React,  { Component } from 'react'
import { connect } from 'react-redux'
import InputText from '../components/formulario/InputText'
import {    LOGIN as loginActions,
    USUARIO as guardarUsuarioActions,
    PASO_ACTUAL_F1 as actualizaPasoActualActions,
    LOGOUT as logoutAction} from '../../service/actions'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

class ResetPassword extends Component {
    state = {
        
        password: '',
        v_password: '',
        usuario: '',
        v_usuario: '',
        codigo: '',
        v_codigo: '',
        v_login : false,
        cancelar: false
    }

    onChange = (e) => {
        let { value , name } = e.target;
        this.setState({[name] : value}, () => {this.validarCampos()})
    }

    componentWillMount(){
        this.setState({usuario: this.props.username})
    }

    validarCampos = () => {
        if(this.state.usuario !== '' && this.state.codigo !== '' && this.state.password !== '')
        {
            this.setState({v_login : true});
        }
    }

    cancelar = () => {
        this.setState({cancelar: true}, () => {this.props.onClick(this.state);});
    }

    render(){
        return(
            <div className="login">
                {/* <p className='welcome-ss'>Hola!</p> */}
                {/* <p className='welcome-ss-tranqui'>Usted Solicito restablecer su contraseña</p> */}

                <p className={'guia-parrafo '+ (this.props.hintPassword ? 'guia-rojo' : '')}>Usted Solicito restablecer su contraseña. <b>Verificar Código en el correo registrado.</b> La nueva contraseña debe tener un tamaño mínimo de 8 caracteres. Además debe contener letras mayúsculas, minúsculas, números y caracteres especiales.</p>
                
                <InputText 
                    name = "usuario"
                    value = {this.state.usuario}
                    placeholder="Usuario"
                    onChange={this.onChange}
                    onBlur={()=>{}}
                    validate={this.state.v_usuario}
                    // minLength="8"
                    // maxLength="50"
                    origen="login"
                    mensaje=""
                    type = "text" 
                    disabled={true} />

                <InputText 
                    name = "codigo"
                    value = {this.state.codigo}
                    placeholder="Codigo"
                    onChange={this.onChange}
                    onBlur={()=>{}}
                    validate={this.state.v_codigo}
                    // minLength="8"
                    // maxLength="50"
                    origen="login"
                    mensaje=""
                    type = "text" />

                <InputText 
                    name = "password"
                    value = {this.state.password}
                    placeholder="Nueva Contraseña"
                    onChange={this.onChange}
                    onBlur={()=>{}}
                    validate={this.state.v_password}
                    minLength="8"
                    maxLength="50"
                    origen="login"
                    mensaje=""
                    type = "password" />
                
                {/* {this.state.m_verifpassword === '' ? null : <span className={ (this.state.v_password && this.state.v_verifpassword) ? "message-success" : "message-error"}>* {this.state.m_verifpassword}</span> }   */}
                <Row>  
                <Col className="s6"> 
                <div className="input-button">
                    <button onClick={()=>this.props.onClick(this.state)} className={this.state.v_login === true?"btn-login btn-small w100 no-box-shadow":"btn-login-inactive btn-small w100 no-box-shadow"}>
                        RESTABLECER
                    </button>
                </div>
                </Col>  
                <Col className="s6">
                <div className="input-button">
                    <button onClick={()=>this.cancelar()} className={"btn-login btn-small w100 no-box-shadow"}>
                        CANCELAR
                    </button>
                </div>
                </Col>
                </Row>
            </div>
        )
    }

}

const mapStateToProps = store => {
    return {
        usuario : store.usuario
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actualizarLogin : (isLogin) => dispatch(loginActions(isLogin)),
        guardarUsuario: (custom) => dispatch(guardarUsuarioActions(custom)),
        actualizaPasoActual : (paso) => dispatch(actualizaPasoActualActions(paso)), 
        logout : () => dispatch(logoutAction())    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)